const axios = require('axios');
const md5 = require('md5');

// 读取cookies
const getCookie = (name) => {
  let arr; const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  if (arr = document.cookie.match(reg)) {
    return decodeURIComponent(arr[2]);
  }
  return null;
};


const beaconRequest = async (type = 'show_docs_page', params = { name: '', path: '' }, userAgent) => {
  // 公用参数
  const loginLevel = getCookie('login_level') || '';
  const loginType = getCookie('login_type') || '';
  const { width, height } = window.screen;
  const options = {
    baseURL: 'https://otheve.beacon.qq.com/analytics/v2_upload?appkey=0WEB05T8XT4T38CC',
    method: 'post',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    data: {
      appVersion: '1.0.0', // 必须，value 可以为空
      sdkId: 'js', // 必须，直接填js即可
      sdkVersion: '4.5.9-web', // 必须，value 可以为空，也可以直接填示例值
      mainAppKey: '0WEB05T8XT4T38CC', // 必须，value为业务标识，从datahub申请的appkey值
      platformId: 3, // 必须！！直接填3
      common: { // 公参集合，必须，集合中的字段会在server处理过程中添加到每个事件中，事件中携带字段覆盖common。
        A2: md5(userAgent), // 设备标识，用于标识用户身份，必须，可以业务自己生成，建议16位或32位随机数。
        A12: 'zh-CN',
        A17: `${width}*${height}*1`,
        A101: userAgent,
        A102: window.location.href,
        A104: document.referrer,
        A23: `web_${process.env.NODE_ENV}`
      },
      events: [// 事件集合。必须
        {
          eventCode: type, // 事件名，必须。
          eventTime: Date.now().toString(), // 事件时间，毫秒值。必须
          mapValue: {
            login_level: loginLevel,
            login_type: loginType,
            ...params,
          }
        }
      ]
    }
  };
  return new Promise((resolve, reject)=>{
    axios(options)
      .then(res=>{
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export default beaconRequest;
